module.exports = __webpack_public_path__ + "static/media/b60.772a48ce.jpg";